import { render, staticRenderFns } from "./SmsDialog.vue?vue&type=template&id=a530ecbe&scoped=true&"
import script from "./SmsDialog.vue?vue&type=script&lang=js&"
export * from "./SmsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a530ecbe",
  null
  
)

export default component.exports